<template>
	
	<div class="wizard-component with-textarea">

		<div class="inputs">
			<div class="input-container" v-for="input in textareas">
				<p class="subject">{{ input.subject }}</p>
				<div class="input-inner">
					<textarea></textarea>
				</div>
				
				<span class="small-text">{{ input.comment }}</span>
			</div>
		</div>

	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			textareas: [
				{
					subject: 'Textarea for longer text here'
				}
			]

		})

	}
</script>


<style></style>